<template>
    <div class="redirect">

    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        beforeCreate () {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            var currentOs = "PC";
            if (/windows phone/i.test(userAgent)) {
                currentOs = "Windows Phone";
            }
            if (/android/i.test(userAgent)) {
                currentOs = "Android";
            }
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                currentOs = "iOS";
            }
            if(currentOs == "PC")
                location.href = "https://biggergames.net";

            
            // fb pixel init
            var fbPixelId = "445490489429270";
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', fbPixelId); 

            var site_id      = "FTBRedirect";
            var camp_ios     = "https://track.tenjin.io/v0/click/cKoThL0Qm8TU5UENlj6VlZ";
            var camp_android = "https://track.tenjin.io/v0/click/e4YoEG8kwrYIQv51ankLBB";
            
            var params = {};
            window.location.search.substr(1).split("&").forEach(function(item) { params[item.split("=")[0]] = item.split("=")[1] });
            var utm_source = params.site_source_name;
            //var utm_medium = params.placement; // ignored
            var utm_campaign = params.name;
            var ad_id = params.adid;
            var os = params.os;
            var campType = params.camp;

            var _camp = camp_ios;
            if(os == "ios"){
                _camp = camp_ios; 
            }
            else if (os == "android") {
                _camp = camp_android;
            }


            fbq('track', 'PageView');

            var red_URL = `${_camp}?advertising_id=${ad_id}&site_id=${site_id}&ad_network=${utm_source}&campaign_name=${utm_campaign}`;
            window.location.href = red_URL;
            
        }
    }
</script>

<style lang="scss" scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/views/traffic/RedirectFTB.vue